module.exports = __webpack_public_path__ + "static/media/it.32955f22.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icons/it.svg
// module id = 2010
// module chunks = 1